import i18n from '@/libs/i18n';
import VueCompositionAPI from '@vue/composition-api';
import { ModalPlugin, ToastPlugin } from 'bootstrap-vue';
import swal from 'sweetalert2';
import VeeValidate, { Validator } from 'vee-validate';
import Vue from 'vue';
import Notifications from 'vue-notification';
import VueTheMask from 'vue-the-mask';
import App from './App.vue';
import { setupJwtIntegration } from './auth/jwt/jwtIntegration';
import router from './router';
import store from './store';

import VueLodash from 'vue-lodash';
import lodash from 'lodash';

window.Swal = swal;

// Initialize JWT integration with user store
setupJwtIntegration();

// CommonJS

// Global Components
import './global-components';

// Customer Validation Rules
Validator.extend('in_array', {
  getMessage: (field, values) => {
    // Handle both array and comma-separated string formats
    const valuesArray = Array.isArray(values) ? values : values.split(',');
    return `The ${field} must be one of: ${valuesArray.join(', ')}`;
  },
  validate: (value, values) => {
    // Handle both array and comma-separated string formats
    const valuesArray = Array.isArray(values) ? values : values.split(',');
    return valuesArray.includes(value);
  },
});

// 3rd party plugins
import '@/libs/acl';
import '@/libs/clipboard';
import '@/libs/portal-vue';
import '@/libs/sweet-alerts';
import '@/libs/toastification';
import '@/libs/tour';
import '@/libs/vue-select';
import '@axios';

// Axios Mock Adapter
import '@/@fake-db/db';

// BSV Plugin Registration
Vue.use(VueCompositionAPI);
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(VeeValidate, {
  inject: false,
});

import { registerValidationRules } from '@/utils/validationRules';
registerValidationRules();

Vue.use(VueLodash, { lodash: lodash });

Vue.use(Notifications);
Vue.use(VueTheMask);

// Composition API
// Feather font icon - For form-wizard
// * Shall remove it if not using font-icons of feather-icons - For form-wizard
require('@core/assets/fonts/feather/iconfont.css'); // For form-wizard

// import core styles
require('@core/scss/core.scss');

// import assets styles
require('@/assets/scss/style.scss');

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
